import type { Command } from "../types.ts";

export const help: Command = {
  name: "help",
  aliases: ["h", "?", "commands"],
  description: "List everything you can type here.",
  run(ctx) {
    ctx.printHTML(`<span class="label">available commands</span>`);
    ctx.print("");
    const cmds = ctx.term.registry.list();
    const pad = Math.max(...cmds.map((c) => c.name.length)) + 2;
    for (const c of cmds) {
      const name = ("/" + c.name).padEnd(pad + 1, " ");
      ctx.printHTML(
        `  <span class="c-accent">${escape(name)}</span><span class="c-muted">${escape(
          c.description,
        )}</span>`,
      );
    }
    ctx.print("");
    ctx.printHTML(
      `<span class="c-muted">tip: <span class="c-text">Tab</span> completes · <span class="c-text">↑/↓</span> history · <span class="c-text">Ctrl+L</span> clears · the leading <span class="c-text">/</span> is optional</span>`,
    );
  },
};

// keep spacing intact in HTML
function escape(s: string): string {
  return s.replace(/ /g, "&nbsp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
